export default __webpack_public_path__ + "static/media/estimate.5e67ee32.svg";